import {createStore, applyMiddleware} from "redux" ;
import logger from "redux-logger";
import reduxThunk from "redux-thunk";
import rootReducer from "./RootReducer";
const middelware =[reduxThunk];
if(process.env.NODE_ENV === "development"){
    middelware.push(logger);
}
const store = createStore(rootReducer , applyMiddleware(...middelware));
export default store ;